// @core/api/endpoints/calendar/get_calendar_policy_by_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarPolicyResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Get entity calendar policy
 * Returns the calendar policy directly attached to the specified entity (if any). Does NOT resolve inheritance — use ResolveCalendarContext for that.
 */
export async function GetCalendarPolicyByEntity(
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<CalendarPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendar/:entity_type/:entity_id/policy`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<CalendarPolicyResponse>(requestPath, { ...requestOptions });
}
